import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadUsers = useCallback(() => {
    setLoading(true);
    api.get('/admin/users')
      .then((res) => setUsers(res.data))
      .catch(() => setError('Nuk arritëm të ngarkonim përdoruesit.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const handleDelete = async (id) => {
    if (!window.confirm('A jeni të sigurt që doni të fshini këtë përdorues?')) return;
    try {
      await api.delete(`/admin/users/${id}`);
      toast.success('Përdoruesi u fshi.');
      loadUsers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gabim gjatë fshirjes.');
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">Përdoruesit</h1>
          <p className="admin-page-sub">Lista e përdoruesve të regjistruar në admin</p>
        </div>
        <Link to="/admin/perdoruesit/i-ri" className="btn btn-primary">
          <Plus size={15}/> Përdorues i ri
        </Link>
      </div>

      <div className="card">
        {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
        {loading ? (
          <div className="spinner" />
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Emri</th>
                  <th>Email</th>
                  <th>Roli</th>
                  <th>Statusi</th>
                  <th>Logimi i fundit</th>
                  <th>Veprimet</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.is_active ? 'Aktiv' : 'Jo aktiv'}</td>
                    <td>{user.last_login ? new Date(user.last_login).toLocaleString('sq-AL') : 'Nuk ka'}</td>
                    <td>
                      <div className="action-btns">
                        <Link to={`/admin/perdoruesit/${user.id}/ndrysho`} className="btn btn-secondary btn-sm">
                          <Edit size={13}/>
                        </Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(user.id)}>
                          <Trash2 size={13}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {users.length === 0 && (
                  <tr>
                    <td colSpan={7} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem' }}>
                      Nuk ka përdorues.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
